import styled from 'styled-components';

export const TestimoniesPageContainer = styled.div`
  background-color: #d4af37;
  color: #000000;
`;

export const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 1.6rem;
`;

export const IntroText = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
`;

export const CategoriesBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 0 24px;
`;

export const CategoryButton = styled.button`
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 0.85rem;
  border: 1px solid #d4af37;
  background-color: ${(props) => (props.$active ? '#d4af37' : '#ffffff')};
  color: ${(props) => (props.$active ? '#ffffff' : '#000000')};
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
`;

export const CategoryDescription = styled.div`
  font-size: 0.85rem;
  margin-top: 4px;
  color: #555555;
`;

export const PostsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const PostCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 0.9rem;
  background-color: #ffffff;
`;

export const PostImageWrapper = styled.div`
  margin-bottom: 8px;
`;

export const PostTitle = styled.h3`
  margin: 0 0 4px;
  font-size: 1rem;
`;

export const PostMeta = styled.div`
  font-size: 0.8rem;
  color: #555555;
  margin-bottom: 8px;
`;

export const PostDescription = styled.div`
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const FeaturedBadge = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #2e7d32;
  color: #ffffff;
  font-size: 0.7rem;
`;
